import React, { useEffect, useRef, useState } from "react";
import { ActionDropdownProps } from "../types";
import {
  ActionClockIcon,
  ActionDropdownContainer,
  ActionDropdownContent,
  ActionDropdownIcon,
  ActionDropdownLabel,
  ActionDropdownOption,
  ActionDropdownOptions,
  ActionDropdownPlaceholder,
  ActionDropdownValue,
  ActionDropdownValueText,
} from "../styles";
import { ReactComponent as DropdownDownIconSvg } from "../assets/dropdown-iterative-down.svg";
import { ReactComponent as DropdownUpIconSvg } from "../assets/dropdown-iterative-up.svg";
import { ReactComponent as ClockIconSvg } from "../assets/clock.svg";

export const ActionDropdown: React.FC<ActionDropdownProps> = ({
  actions,
  selectedAction,
  onActionSelect,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleActionSelect = (action: any) => {
    if (!disabled) {
      onActionSelect(action);
      setIsOpen(false);
    }
  };

  return (
    <ActionDropdownContainer
      ref={dropdownRef}
      onClick={handleToggle}
      disabled={disabled}
    >
      <ActionDropdownContent disabled={disabled}>
        {disabled ? (
          <>
            <ActionClockIcon>
              <ClockIconSvg />
            </ActionClockIcon>
            <ActionDropdownValueText disabled={disabled}>
              {selectedAction ? selectedAction.description : "Select an Action"}
            </ActionDropdownValueText>
          </>
        ) : (
          <>
            <ActionDropdownPlaceholder>
              <ActionDropdownLabel disabled={disabled}>
                Action
              </ActionDropdownLabel>
            </ActionDropdownPlaceholder>
            <ActionDropdownValue>
              <ActionDropdownValueText disabled={disabled}>
                {selectedAction
                  ? selectedAction.description
                  : "Select an Action"}
              </ActionDropdownValueText>
            </ActionDropdownValue>
          </>
        )}
      </ActionDropdownContent>
      {!disabled && (
        <ActionDropdownIcon>
          {isOpen ? <DropdownUpIconSvg /> : <DropdownDownIconSvg />}
        </ActionDropdownIcon>
      )}

      {isOpen && !disabled && (
        <ActionDropdownOptions>
          {actions.map((action: any) => (
            <ActionDropdownOption
              key={action.id}
              onClick={() => handleActionSelect(action)}
            >
              {action.description || action.name}
            </ActionDropdownOption>
          ))}
        </ActionDropdownOptions>
      )}
    </ActionDropdownContainer>
  );
};
